import React from "react";
import { Box } from "@mui/material";
import Badge from "components/basic/badge";
import { GoogleLinkReview } from "generated/graphql";

import {
  GOOGLE_REVIEW_LABELS,
  VERIFICATION_COLORS,
  VERIFICATION_LABELS,
} from "../../../../constants";
import { AdminVendor } from "../../../../types";

const VendorStatusBadges: React.FC<{ vendor: AdminVendor }> = ({ vendor }) => (
  <Box display="flex" flexWrap="wrap" gap={0.5} justifyContent="center">
    {vendor.suspendedAt && <Badge label="Suspended" color="#d32f2f" />}
    {vendor.vendor.pausedAt && <Badge label="Paused" color="#d32f2f" />}
    {vendor.vendor.reverificationRequestedAt && (
      <Badge label="Changes to review" color="#ed6c02" />
    )}
    <Badge
      label={VERIFICATION_LABELS[vendor.vendor.verificationStatus]}
      color={VERIFICATION_COLORS[vendor.vendor.verificationStatus]}
    />
    {vendor.vendor.googlePlaceId &&
      vendor.googleLinkStatus !== GoogleLinkReview.Approved && (
        <Badge
          label={`Google: ${GOOGLE_REVIEW_LABELS[vendor.googleLinkStatus]}`}
          color={
            vendor.googleLinkStatus === GoogleLinkReview.Rejected
              ? "#d32f2f"
              : "#ed6c02"
          }
        />
      )}
  </Box>
);

export default VendorStatusBadges;
